import React, { useCallback, useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import IconButton from "../../components/common/IconButton";
import { MdDelete } from "react-icons/md";
import FormTextField from "../../components/formFields/FormTextField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormTextArea from "../../components/formFields/FormTextArea";
import FormSelectionField from "../../components/formFields/FormSelectionField";

const BestTimeToVisitArray = (fieldArrayRenderProps: FieldArrayRenderProps) => {
  const dispatch = useAppDispatch();
  const [deleteIndex, setDeleteIndex] = useState(-1);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const handleOpenDeleteDialog = (index: number) => {
    dispatch(openDialog("deleteBestTimeToVisit"));
    setDeleteIndex(index);
  };
  const handleDeleteAction = useCallback(
    (index: number) => {
      fieldArrayRenderProps.onRemove({ index: index });
      dispatch(closeDialog());
      setDeleteIndex(-1);
    },
    [fieldArrayRenderProps],
  );
  const pushElementInarray = useCallback(() => {
    fieldArrayRenderProps.onPush({
      value: {
        Title: "",
        Description: "",
      },
    });
  }, [fieldArrayRenderProps]);
  if (!fieldArrayRenderProps?.value?.length) {
    pushElementInarray();
  }

  return (
    <>
      <GridLayoutItem
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography.h4>Add Best Time To Visit</Typography.h4>
        <div>
          <Button
            fillMode={"solid"}
            themeColor={"primary"}
            onClick={pushElementInarray}
            type="button"
          >
            Add New
          </Button>
        </div>
      </GridLayoutItem>

      {dialogName === "deleteBestTimeToVisit" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Best Time To Visit"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Best Time To Visit?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(deleteIndex)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
      <GridLayoutItem
        style={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        <GridLayout
          style={{ marginRight: 10 }}
          gap={{ rows: 10, cols: 10 }}
          cols={[{ width: "50%" }, { width: "50%" }]}
        >
          {fieldArrayRenderProps.value &&
            fieldArrayRenderProps.value.length > 0 &&
            fieldArrayRenderProps.value?.map(
              (BestTimes: any, index: number) => (
                <div
                  key={index}
                  style={{
                    padding: "0 20px 20px 20px",
                    border: "1px solid orange",
                    borderRadius: 8,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                    }}
                  >
                    <Field
                      name={`BestTimes.${index}.Title`}
                      label="Title"
                      placeholder="Title"
                      component={FormTextField}
                      validator={requiredValidator}
                      astrike={true}
                      wrapperClassName="w-100"
                    />
                    <div>
                      <Field
                        name={`BestTimes.${index}.SeasonType`}
                        label="Season Type"
                        placeholder="Category"
                        component={FormSelectionField}
                        validator={requiredValidator}
                        astrike={true}
                        options={[
                          {
                            label: "All Season",
                            value: "All Season",
                          },
                          {
                            label: "Summer",
                            value: "Summer",
                          },
                          {
                            label: "Monsoon",
                            value: "Monsoon",
                          },
                          {
                            label: "Winter",
                            value: "Winter",
                          },
                        ]}
                      />
                    </div>
                    <div>
                      <IconButton
                        onClick={() => handleOpenDeleteDialog(index)}
                        disabled={fieldArrayRenderProps?.value?.length === 1}
                        themeColor={"error"}
                        size={"small"}
                        fillMode={"solid"}
                        type="button"
                        style={{
                          marginTop: 35,
                          height: 30,
                          width: 30,
                        }}
                        icon={MdDelete}
                        iconClassName="absolute-position"
                        iconStyle={{ fontSize: "24px" }}
                      />
                    </div>
                  </div>
                  <div>
                    <Field
                      name={`BestTimes.${index}.Description`}
                      label="Description"
                      component={FormTextArea}
                      validator={requiredValidator}
                      astrike={true}
                      rows={2}
                    />
                  </div>
                </div>
              ),
            )}
        </GridLayout>
      </GridLayoutItem>
    </>
  );
};

export default BestTimeToVisitArray;
